import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';

import { FuseSharedModule } from '../../../@fuse/shared.module';

import { FuseFooterComponent } from './footer.component';
import { DefaultDataService } from 'src/app/services/default-data.service';

@NgModule({
    declarations: [
        FuseFooterComponent
    ],
    imports: [
        RouterModule,
        MatToolbarModule,

        FuseSharedModule,
    ],
    exports: [
        FuseFooterComponent
    ],
    providers: [
        //         DefaultDataService,
    ]
})
export class FuseFooterModule {
}
